export default {
    id: "fsb-sorm-2026",
    articleType: "custom",
    slug: "sorm-dlya-ekspeditorov-2026",
    date: "30 июля 2026",
    dateTime: "2026-07-30",
    modifiedTime: "2026-07-30",
    author: "Редакция «Светофор Логистика»",
    category: "Экспедиторам · 2026",
    contentType: "Статья",
    title:
        "СОРМ для экспедиторов в 2026 году: требования ФСБ, хранение данных и штрафы",
    sidebarTitle: "СОРМ для экспедиторов в 2026 году",
    seoTitle:
        "СОРМ для экспедиторов в 2026 году: требования ФСБ | «Светофор Логистика»",
    seoDescription:
        "Разбираем требования СОРМ для экспедиторов в 2026 году: взаимодействие с ФСБ, сроки, хранение данных, штрафы и решение «Светофор Логистика».",
    image:
        "/img/news/sorm-dlya-ekspeditorov-2026/cover.webp",
    imageAlt:
        "СОРМ, защищённое хранение данных и логистика для экспедиторов",
    featured: {
        badgeKey: "main.landing.news.items.fsbSorm2026.badge",
        metaKey: "main.landing.news.items.fsbSorm2026.meta",
        titleKey: "main.landing.news.items.fsbSorm2026.title",
        descriptionKey: "main.landing.news.items.fsbSorm2026.description",
        actionKey: "main.landing.news.items.fsbSorm2026.action",
    },
};
